import { cx } from '@mage-ui/styled-system/css';
import { navMenu } from '@mage-ui/styled-system/recipes';
import { Transition } from '@mantine/core';
import { useState } from 'react';
import { NavItem } from '../nav-item/NavItem';
import { NavItemBtn } from '../nav-item/NavItemBtn';
import { NavSubMenu } from '../nav-submenu/NavSubMenu';

export const NavMenu = ({ data, className, a11yLabel, ...props }) => {
	const [openItem, setOpenItem] = useState(null);
	const links = data?.relations?.Links || [];

	const handleToggle = (index) => {
		setOpenItem((prev) => (prev === index ? null : index));
	};

	return (
		<ul
			className={cx(navMenu().root, className)}
			aria-label={a11yLabel}
			{...props}
		>
			{links.map((link, index) => {
				const hasSubLinks = link.relations?.Links?.length > 0;
				const isExpanded = openItem === index;
				return (
					<li key={`${link.meta?.key} + ${index}`} className={navMenu().item}>
						{hasSubLinks ? (
							<>
								<NavItemBtn data={link} onClick={() => handleToggle(index)} />
								<Transition
									mounted={isExpanded}
									transition='fade'
									duration={200}
									timingFunction='ease'
									keepMounted={true}
								>
									{(transitionStyle) =>
										isExpanded && (
											<NavSubMenu
												data={link?.relations?.Links}
												style={{ ...transitionStyle, zIndex: 1 }}
											/>
										)
									}
								</Transition>
							</>
						) : (
							<NavItem data={link} />
						)}
					</li>
				);
			})}
		</ul>
	);
};
